// extracted by mini-css-extract-plugin
export default {"noDataWrapper":"_errors_noDataWrapper__olVCG","noRaceDataWrapper":"_errors_noRaceDataWrapper__MHABC"};